module.exports = __webpack_public_path__ + "static/media/cedula_dorso@2x.9ef4ab8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/cedula_dorso@2x.jpg
// module id = 347
// module chunks = 0